import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class EmptyBarrel extends DestroyableObstacle {
	static key = "EmptyBarrel";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	static deserialize(data: any): EmptyBarrel {
		const b = new EmptyBarrel(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
